import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import SubscriptionLockIcon from "./SubscriptionLockIcon.jsx";
import AdministratorOnlyIcon from "./AdministratorOnlyIcon.jsx";
import {isAdministratorOnlyRoute} from "../../../utils/routeAccess.js";

function SidebarLinkGroupLinkDesign({name, locked, administratorOnly}) {
    const {t} = useTranslation();
    const administratorOnlyLabel = t("route.administrator_only", {defaultValue: "Pouze pro administrátory"});

    return <span
        className="submenu-link flex items-center gap-1.5 text-sm font-medium lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
            {name}
            {locked && <SubscriptionLockIcon/>}
            {administratorOnly && <span
                className="inline-flex text-violet-500"
                title={administratorOnlyLabel}
                aria-label={administratorOnlyLabel}
            ><AdministratorOnlyIcon/></span>}
        </span>;
}

export default function SidebarLinkGroupLink({route, onLockedClick}) {
    let current = route['is_current'];
    let administratorOnly = isAdministratorOnlyRoute(route);
    let linkClass = route['is_current'] ? '!text-violet-500' : '!text-gray-500/90 hover:!text-gray-800 dark:!text-gray-400 dark:hover:!text-gray-200';

    if (route['name'] === null) {
        return <li></li>;
    }

    return (<li className="mb-1 last:mb-0">
        {route['path'] && (route.lockedBySubscription
            ? <button type="button" className={`block w-full truncate text-left transition ${linkClass}`} onClick={() => onLockedClick(route)}>
                <SidebarLinkGroupLinkDesign name={route['name']} locked administratorOnly={administratorOnly}/>
            </button>
            : <NavLink className={`block transition truncate ${linkClass}`} end to={route['path']}>
                <SidebarLinkGroupLinkDesign name={route['name']} administratorOnly={administratorOnly}/>
            </NavLink>)}
        {route['href'] && <a target={'_blank'} href={route['href']}>
            <SidebarLinkGroupLinkDesign name={route['name']} administratorOnly={administratorOnly}/>
        </a>}
    </li>);
}
